import {Button, Image, Modal} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState,} from 'react'
import {DelayRender} from 'views/Discovery/DelayRender'
import {NullAsDefault} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {LayoutContext} from '../../../components/layouts/Default/LayoutContext'
import {getFullAddress, getResponseItem, LoadingWrapper, renderIf, renderIfElse} from '../../Shared'
import {NoneStickyMeta} from '../EntityList'
import {showDeleteConfirmDialog} from '../factory/createConfirmDialog'
import createContextMenu from '../factory/createContextMenu'
import {bindQueryParam, mapPathParam} from '../functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from '../hooks/usePaginationHelper'
import {church_getById_Api, church_getChurchMassTimeById_Api, church_getMassTimesByChurch_Api} from "../../../apis";
import Async from "../../../modules/asyncCache/components/Async";
import {ListHeaderWithLine} from "../Templates/items/ListHeader";
import {CreateChurchMassTimeForm, EditChurchMassTimeForm} from "./components/ChurchMassTimeForm";
import {BiSolidChurch, BiSolidEdit, BiTrash} from "react-icons/bi";
import useAsync from "../../../modules/asyncCache/useAsync";
import {PermissionEntity} from "../Permissions/PermissionEntity";
import ChurchEntity from "./ChurchEntity";
import {getId} from "../../../apis/model/base";
import {useChurchMassTimes} from "./functions/useChurchMassTimes";
import {renderChurchMassTime} from "./functions/renderChurchMassTime";
import {ItemInformation} from "../Organization/OrganizationEntity";
import {GiPopeCrown} from "react-icons/gi";
import {addFavorite} from "../../../helpers/localStorage";
import TooltipApp from "components/TooltipApp";
import {HiViewfinderCircle} from "react-icons/hi2";
import LoadingBlock from "../../LoadingBlock";

const ChurchContext = React.createContext({})


export const ChurchProvider = ({
                                   item,
                                   children,
                                   ...props
                               }) => {

    const apiInfo = church_getById_Api

    const id = getId(item) || item

    const cacheId = mapPathParam(apiInfo.path, {id})

    const {response, isLoading = false} = useAsync({
        apiInfo,
        query: bindQueryParam({id}),
    })

    const isSucceed = Number(_.get(response, 'status')) === 200

    const cache = getResponseItem(response)

    const error = getResponseItem(response, 'error')

    const errorMessage = _.get(response, 'errorMessages.error')

    const error_code = _.get(response, 'errorMessages.error_code')

    const status = {
        title: getResponseItem(response, 'status'),
        description: errorMessage,
    }


    const renderHeader = useCallback((action, isModal) => null, [])

    return (
        <LoadingWrapper isLoading={!item}>
            <ChurchEntity
                key={cacheId}
                item={id}>
                {(item) => {

                    if (item) {
                        addFavorite("churches", _.pick(item, ['_type', 'id', 'idname', 'name', 'photo']))
                    }
                    return (
                        <PermissionEntity item={item}>
                            <ChurchContext.Provider
                                value={{
                                    id,
                                    isLoading,
                                    item,
                                    error,
                                    cache,
                                    status,
                                    isSucceed,
                                    error_code,
                                    renderHeader,
                                    errorMessage,
                                    ...props,
                                }}>
                                {children}
                            </ChurchContext.Provider>
                        </PermissionEntity>
                    )
                }}
            </ChurchEntity>
        </LoadingWrapper>
    )
}

export const ChurchManager = ({
                                  church_id,
                                  Wrapper = 'div',
                                  filter_actions = {
                                      sortBy: 'sort-by',
                                      keyword: 'keyword',
                                  },
                              }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const [refreshKey, setRefreshKey] = useState()

    const [action, setAction] = useState({type: undefined, value: undefined})

    const refresh_deps = [church_id, refreshKey]

    const onCancel = () => {
        setAction({})
    }

    const onSuccess = () => {
        onCancel()
        setRefreshKey(Date.now())
    }

    const {onCreate, onUpdate, onDelete} = useChurchMassTimes({
        church_id,
        notifyListeners: {
            onCreated: onSuccess,
            onUpdated: onSuccess,
            onDeleted: onSuccess,
        },
    })

    const renderContextMenu = useCallback((item) => {
            return createContextMenu(
                [
                    {
                        icon: <BiSolidEdit className="text-blue-500"/>,
                        label: <span className="text-sm text-color-200">{t('edit')}</span>,
                        key: CRUD.UPDATE,
                    },
                    {
                        icon: <BiTrash className="text-primary-300"/>,
                        label: <span className="text-sm text-color-200">{t('delete')}</span>,
                        key: CRUD.DELETE,
                    },
                ],
                (key) => {
                    switch (key) {
                        case CRUD.UPDATE:
                            setAction({type: key, value: item})
                            break
                        case CRUD.DELETE:
                            const id = item?.id
                            if (id) {
                                showDeleteConfirmDialog({
                                    translate: t,
                                    title: 'delete this mass times',
                                    message: 'are you sure you want to delete this mass times',
                                    onOk: () => {
                                        onDelete(
                                            {},
                                            {
                                                id,
                                            }
                                        )
                                    },
                                })
                            }
                            break
                        default:
                            break
                    }
                }
            )
        }
        , [])

    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        renderFilter: NullAsDefault,
        AdvancedFilter: NullAsDefault,
        query_params: filter_actions,
        withKey: createPagerKey(refresh_deps),
        pagerInfo: {
            RenderEntity: React.Fragment,
            query: bindQueryParam({
                id: church_id,
            }),
            PaginationMeta: NoneStickyMeta,
            apiInfo: church_getMassTimesByChurch_Api,
            renderItem: renderChurchMassTime({
                translate: t,
                renderContextMenu,
                handleAction: (type, value) => {
                    setAction({type, value});
                }
            }),
            renderWrap: (child) => (
                <div className="flex flex-col gap-2">
                    {child}
                </div>
            ),
        },
        renderHeader: ([searchBar, filterBar]) => (
            <React.Fragment>
                {filterBar}
                <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-3">
                        {searchBar}
                        <Button
                            type="primary"
                            className="button-rounded-md no-border text-sm"
                            onClick={() => {
                                setAction({type: CRUD.CREATE})
                            }}>
                            {t('add new')}
                        </Button>
                    </div>
                    <ListHeaderWithLine title={t('list of mass times of church')} className="text-sm"/>
                </div>
            </React.Fragment>
        ),
    })

    const modal = useMemo(() => {
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {}
        let modal_params = {}
        switch (action.type) {
            case CRUD.CREATE:
                params = {
                    onSubmit: (values) => {
                        onCreate(values)
                    },
                }
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('create new mass times')}
                        </div>
                    ),

                }
                Content = CreateChurchMassTimeForm
                break
            case CRUD.UPDATE:
                params = {
                    onSubmit: (values) => {
                        onUpdate(values, {id: action.value?.id})
                    },
                }
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('edit')}
                        </div>
                    ),
                }
                Content = EditChurchMassTimeForm
                Wrapper = ({children}) => (
                    <Async
                        {...{
                            query: bindQueryParam({id: action.value?.id}),
                            apiInfo: church_getChurchMassTimeById_Api,
                        }}>
                        {({isLoading, response}) =>
                            _.isFunction(children)
                                ? children({
                                    isLoading,
                                    initialValues: getResponseItem(response),
                                })
                                : children
                        }
                    </Async>
                )
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                open={action.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <DelayRender lazy={true}>
                    <Wrapper>
                        {({isLoading, initialValues}) => {
                            if (!!isLoading) {
                                return <LoadingBlock/>
                            }
                            return (
                                <Content
                                    {...{
                                        onCancel,
                                        item: action.value,
                                    }}
                                    {...params}
                                    initialValues={initialValues}
                                />
                            )
                        }}
                    </Wrapper>
                </DelayRender>
            </Modal>
        )
    }, [action])

    return (
        <ChurchProvider item={church_id}>
            <ChurchContext.Consumer>
                {({item}) => {
                    const {
                        photo, cover_photo,
                        name,
                        contact_name,
                        contact_phone,
                        archdiocese,
                        diocese,
                        deanery,
                        parish,
                        is_cathedral,
                    } = item ?? {}

                    return (
                        <Wrapper className="flex flex-col px-0 md:px-3 space-y-3">
                            <div className="relative custom-img-view">
                                <Image
                                    src={cover_photo || './images/find-a-church.webp'}
                                    fallback={'./images/find-a-church.webp'}
                                    style={{height: isSm ? 120 : 150}}
                                    className="rounded-lg object-cover"
                                    wrapperClassName="rounded-lg"
                                    preview={{
                                        mask: (
                                            <div className="w-full h-full relative">
                                                <HiViewfinderCircle
                                                    size={16}
                                                    style={{top: 10, right: 10}}
                                                    className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                                {renderIf(
                                    !!is_cathedral,
                                    <TooltipApp title={t('cathedral')} placement="right"
                                                classNames={{root: "font-medium text-xs italic"}}>
                                        <GiPopeCrown
                                            size={30}
                                            style={{top: 10, left: 10}}
                                            className="absolute text-white opacity-75 hover:opacity-100 hover:text-primary-600 cursor-pointer"
                                        />
                                    </TooltipApp>
                                )}
                            </div>
                            <div className="flex flex-col gap-2 mb-3">
                                <div className="flex items-center gap-3 border-b-2 border-primary pb-1">
                                    <BiSolidChurch size={18} className="text-primary-300"/>
                                    <span
                                        className="flex-1 font-bold text-xl text-primary uppercase truncate tracking-wide leading-tight">
                                        {name}
                                    </span>
                                </div>
                                <div className="space-y-1 ml-0 md:ml-3">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1">
                                        <ItemInformation className="text-sm lg:text-xs" label="archdiocese"
                                                         value={archdiocese?.fullname}/>
                                        <ItemInformation className="text-sm lg:text-xs" label="diocese"
                                                         value={diocese?.fullname}/>
                                        <ItemInformation className="text-sm lg:text-xs" label="deanery"
                                                         value={deanery?.fullname}/>
                                        <ItemInformation className="text-sm lg:text-xs" label="parish"
                                                         value={parish?.fullname}/>
                                    </div>
                                    {renderIf(
                                        _.some([contact_name, contact_phone]),
                                        <div className="flex items-center gap-1 text-sm lg:text-xs">
                                          <span className="text-color-400 whitespace-no-wrap italic">
                        {`${t('contact')} : `}
                      </span>
                                            {renderIfElse(
                                                contact_name && contact_phone,
                                                <span className="font-semibold text-color-000">
                            {`${contact_name} - ${contact_phone}`}
                          </span>,
                                                <span className="font-semibold text-color-000">
                            {contact_name || contact_phone}
                          </span>
                                            )}
                                        </div>
                                    )}
                                    <div className="flex items-start gap-1 text-sm lg:text-xs">
                    <span className="text-color-400 whitespace-no-wrap italic">
                      {`${t('address')} : `}
                    </span>
                                        <span className="font-semibold text-color-000">
                      {getFullAddress(item)}
                    </span>
                                    </div>
                                </div>
                            </div>
                            {pager_widget}
                            {modal}
                            <div className="h-10"/>
                        </Wrapper>
                    )
                }}
            </ChurchContext.Consumer>
        </ChurchProvider>
    )
}

export default ChurchContext